import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  FilterStream,
  getFilterValues,
  setFilterValues
} from '../shared/Filters';
import { connectStream } from '../../lib/bastetjs/utils/connectStream';
import { DropDown } from '../../components/shared/Elements';
import { getEventOptions}  from '../../data/EventStreams';
import { Loading } from '../shared/Loading';
import { injectIntl } from 'react-intl';
import {
  setEventCourse as setEventCourseStream,
  getEventCourse
} from '../../data/StartListStreams';
import { withRouter } from 'react-router-dom';
import { getStartListUrl } from '../../utils/startListHelpers';

const eventCourseStreamObj = {};

export class StartListFilterComponent extends Component {

  static propTypes = {
    masterId: PropTypes.number.isRequired,
    eventId: PropTypes.number,
    courseId: PropTypes.number,
    intl: PropTypes.object.isRequired,
    t: PropTypes.func
  };

  static defaultProps = {
    eventOptions: {isLoading: true},
    filterValues: {}
  };

  state = {
    eventId: this.props.eventId,
    eventCourseId: this.props.eventCourseId,
    coursePatternIds: {}
  };

  componentDidMount() {
    const {eventCourseId, eventId} = this.props;
    if(eventCourseId || eventId) {
      setTimeout(
        () => this.setFilters({eventId, eventCourseId}), 0);
    }
  }

  setFilters = (filterValues) =>
    setFilterValues(this.getFilterStreamId(), filterValues);

  areFiltersChanged = (nextFilterValues) => {
    const {filterValues: {eventId, eventCourseId}} = this.props;
    return eventId !== nextFilterValues.eventId
      || eventCourseId !== nextFilterValues.eventCourseId;
  };

  setHistoryFromFilters = ({eventCourseId, eventId}) => {
    const {masterId} = this.props;
    this.props.history.replace(
      {pathname: getStartListUrl(masterId, eventId, eventCourseId)});
  };

  isEventChanged = (eventId) => eventId !== this.props.eventId;
  isEventCourseChanged = (eventCourseId) =>
    eventCourseId !== this.props.eventCourseId;
  gotEvent = (eventId) => !this.props.eventId && !!eventId;
  gotEventCourse = (eventCourseId) =>
    !this.props.eventCourseId && !!eventCourseId;
  shouldUpdateFilters = ({eventId, eventCourseId}) => {
    const {filterValues} = this.props;
    return eventId !== filterValues.eventId
      || eventCourseId !== filterValues.eventCourseId;
  };

  componentWillReceiveProps(
    {
      eventOptions,
      masterId,
      eventId,
      eventCourseId,
      filterValues,
      eventCourse
    }) {
    const masterChanged = masterId !== this.props.masterId;

    if(this.props.eventOptions.isLoading && !eventOptions.isLoading ||
      masterChanged) {
      //Get the stream once, so that when we publish to it, stream exists
      if(!eventCourseStreamObj[this.props.masterId]) {
        eventCourseStreamObj[this.props.masterId] = getEventCourse(this.props.masterId);
      }
      this.setEventCourse(eventOptions);
    }

    if(this.gotEvent(eventId)
      || this.gotEventCourse(eventCourseId)
      || this.shouldUpdateFilters({eventId, eventCourseId})) {
      this.setFilters({eventCourseId, eventId});
    }
    if(this.areFiltersChanged(filterValues)) {
      this.setHistoryFromFilters(filterValues);
    }
    if(this.isEventChanged(eventId)) {
      this.changeEvent(eventId)
    }
    if(this.isEventCourseChanged(eventCourseId)) {
      this.changeEventCourse(eventCourseId);
    }
  }

  getFilterStreamId = () => `event-start-list`;

  /**
   * Check components loading state
   * @return {boolean}
   */
  isLoading = () => {
    const {eventOptions} = this.props;
    return !eventOptions || eventOptions.isLoading;
  };

  /**
   * When event is changed then we will need to set event course id to be
   * first course for that event
   * @param eventId
   */
  changeEvent = (eventId) => {
    const courses = this.getCourseOptions(eventId);
    const eventCourseId = courses && courses.length > 0 ?
      courses[0].value : 0;
    this.setState({eventId, eventCourseId}, this.onChange);
  };

  changeEventCourse = (eventCourseId) =>
    this.setState({eventCourseId}, this.onChange);

  /**
   * Build options for events dropdown
   * @return {[]}
   */
  getEventOptions = () => this.props.eventOptions.map(({id, date}) => ({
    value: id,
    label: this.props.intl.formatDate(new Date(date), {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    })
  }));

  /**
   * Build options for event courses drop down.
   * @param {number} eventId
   * @return {[]}
   */
  getCourseOptions = (eventId) => {
    const {eventOptions} = this.props;
    const eventCourses = !eventId ? eventOptions[0] :
      eventOptions.find(({id}) => id === eventId);
    if(!eventCourses) return [];
    else return eventCourses.courses.map(({eventCourseID, courseName}) => ({
      value: eventCourseID, label: courseName
    }));
  };

  /**
   * Builds event course id based on that available.
   * @param {number} eventId
   * @param {[]} eventOptions
   */
  getEventCourseId = (eventId, eventOptions) => {
    const {eventCourseId} = this.state;
    if(eventCourseId) return eventCourseId;
    else return eventOptions.find(({id}) => id === eventId)
      .courses[0].eventCourseID;
  };

  /**
   * Set event course object. Object contains event id, event course id and
   * course pattern id. Also calls onChange to pull new start list
   * @param {[]} eventOptions
   */
  setEventCourse = (eventOptions) => {
    const {
      eventId
    } = this.state;
    const eventCourseId = this.getEventCourseId(eventId, eventOptions);
    const courseIds = eventOptions.reduce((acc, {id, courses}) => {
      acc[id] = courses.reduce((courses, {eventCourseID, courseID}) => {
        courses[eventCourseID] = courseID;
        return courses;
      }, {});
      return acc;
    }, {});
    this.setState({courseIds, eventCourseId}, this.onChange);
  };

  /**
   * Push history and set event course after filter is changed
   */
  onChange = () => {
    const {
      eventId,
      eventCourseId,
      courseIds
    } = this.state;
    const {masterId} = this.props;
    setEventCourseStream(masterId, {
      eventId,
      eventCourseId,
      courseId: courseIds[eventId][eventCourseId]});
    this.pushHistory();
  };


  /**
   * Pushing master id, event id and course id to browser history
   */
  pushHistory = () => {
    const {masterId} = this.props;
    const {eventId, eventCourseId} = this.state;
    this.props.history.replace(
      {pathname: getStartListUrl(masterId, eventId, eventCourseId)});
  };

  render() {
    const {
      isMobile,
      t
    } = this.props;

    if(this.isLoading()) {
      return <Loading timeoutMessage={t('Still thinking...')}/>;
    }

    const {eventId} = this.state;
    const events = this.getEventOptions();
    const courses = this.getCourseOptions(eventId);

    return (
      <FilterStream
        streamId={this.getFilterStreamId()}
        isMobile={isMobile}
        showTitle={false}
        isHorizontal={true}
      >
        <DropDown
          id='eventId'
          label={t('Event')}
          options={events}
        />
        <DropDown
          id='eventCourseId'
          label={t('Race')}
          options={courses}
        />
      </FilterStream>
    );
  }
}

export const StartListFilter = withTranslation()(injectIntl(connectStream({
  eventOptions: ({masterId}) => getEventOptions(masterId),
  filterValues: () => getFilterValues(`event-start-list`)
})(withRouter(StartListFilterComponent))));



/** WEBPACK FOOTER **
 ** ./components/eventStartList/Filters.js
 **/